"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _now = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/date/now"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactAddonsShallowCompare = _interopRequireDefault(require("react-addons-shallow-compare"));

var _QuizRoundHeader = _interopRequireDefault(require("./QuizRoundHeader"));

var _Question = _interopRequireDefault(require("./Question2"));

var _Spinner = _interopRequireDefault(require("../Spinner/Spinner"));

var _cssConstants = _interopRequireDefault(require("../../../../targets/cord_sanofi/cssConstants.js"));

var _DataStore = _interopRequireWildcard(require("../../../KESI2/Stores/DataStore2"));

var _EquizzerActions = _interopRequireDefault(require("./actions/EquizzerActions"));

var _ThemeStore = _interopRequireDefault(require("../ThemeStore/ThemeStore2"));

var _QuizRound = _interopRequireDefault(require("./QuizRound.scss"));

var _QuizRoundStyle = require("./styles/QuizRoundStyle");

var _DeviceInfoHelper = _interopRequireDefault(require("../../../helpers/DeviceInfoHelper"));

var _UserLogsService = _interopRequireDefault(require("./services/UserLogsService"));

var _NavigationManager = _interopRequireDefault(require("../../NavigationManager"));

var _Constants = require("../../constants/Constants");

var _DataStoreComponent2 = _interopRequireDefault(require("../DataStoreComponent/DataStoreComponent2"));

var _ScreenHelper = _interopRequireDefault(require("../../../helpers/ScreenHelper"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var QUESTION_OUTER_DIV_ID = 'qaOuterDiv';
var MOCKED_QUESTION = [{
  answers: [],
  categories: ["BETRIEBSWIRTSCHAFTSLEHRE", "DIHK", "WWQ", "FB1", "BWL", "PROD"],
  correctAnswer: [],
  feedback: "<ul> <li>Ort und Tag der Ausstellung</li> <li>Name und Anschrift des Absenders</li> <li>Stelle und Tag der Übernahme des Gutes sowie die für die Ablieferung vorgesehene Stelle</li> <li>Name und Anschrift des Empfängers</li> <li>die übliche Bezeichnung der Art des Gutes und die Art der Verpackung, bei gefährlichen Gütern ihre allgemein anerkannte Bezeichnung</li> <li>Anzahl, Zeichen und Nummern der Frachtstücke</li> <li>Rohgewicht oder die anders angegebene Menge des Gutes</li> <li>die mit der Beförderung verbundenen Kosten (Fracht, Nebengebühren, Zölle und andere Kosten, die vom Vertragsabschluss bis zur Ablieferung anfallen)</li> <li>Weisungen für die Zoll- und sonstige amtliche Behandlung</li> <li>die Angabe, dass die Beförderung trotz einer gegenteiligen Abmachung den Bestimmungen dieses Übereinkommens unterliegt</li> </ul>  <p>(Rechtsquelle: CMR Art 6(1))</p> ",
  id: "DIHK_WiQ - 200000  ",
  inlineimg: false,
  score: 3,
  question: "Nennen Sie 4 Pflicht-Angaben im CMR Frachtbrief.",
  timelimit: 30,
  type: "SE",
  number: 0,
  duration: 100000
}, {
  answers: [],
  categories: ["BETRIEBSWIRTSCHAFTSLEHRE", "DIHK", "WWQ", "FB1", "BWL", "PROD"],
  correctAnswer: [],
  feedback: "<ul> <li>Ort und Tag der Ausstellung</li> <li>Name und Anschrift des Absenders</li> <li>Stelle und Tag der Übernahme des Gutes sowie die für die Ablieferung vorgesehene Stelle</li> <li>Name und Anschrift des Empfängers</li> <li>die übliche Bezeichnung der Art des Gutes und die Art der Verpackung, bei gefährlichen Gütern ihre allgemein anerkannte Bezeichnung</li> <li>Anzahl, Zeichen und Nummern der Frachtstücke</li> <li>Rohgewicht oder die anders angegebene Menge des Gutes</li> <li>die mit der Beförderung verbundenen Kosten (Fracht, Nebengebühren, Zölle und andere Kosten, die vom Vertragsabschluss bis zur Ablieferung anfallen)</li> <li>Weisungen für die Zoll- und sonstige amtliche Behandlung</li> <li>die Angabe, dass die Beförderung trotz einer gegenteiligen Abmachung den Bestimmungen dieses Übereinkommens unterliegt</li> </ul>  <p>(Rechtsquelle: CMR Art 6(1))</p> ",
  id: "DIHK_WiQ - 200000  ",
  inlineimg: false,
  score: 3,
  question: "Nennen Sie 4 Pflicht-Angaben im CMR Frachtbrief.",
  timelimit: 30,
  type: "SE",
  number: 1,
  duration: 100000
}, {
  answers: [],
  categories: ["BETRIEBSWIRTSCHAFTSLEHRE", "DIHK", "WWQ", "FB1", "BWL", "PROD"],
  correctAnswer: [],
  feedback: "<ul> <li>Ort und Tag der Ausstellung</li> <li>Name und Anschrift des Absenders</li> <li>Stelle und Tag der Übernahme des Gutes sowie die für die Ablieferung vorgesehene Stelle</li> <li>Name und Anschrift des Empfängers</li> <li>die übliche Bezeichnung der Art des Gutes und die Art der Verpackung, bei gefährlichen Gütern ihre allgemein anerkannte Bezeichnung</li> <li>Anzahl, Zeichen und Nummern der Frachtstücke</li> <li>Rohgewicht oder die anders angegebene Menge des Gutes</li> <li>die mit der Beförderung verbundenen Kosten (Fracht, Nebengebühren, Zölle und andere Kosten, die vom Vertragsabschluss bis zur Ablieferung anfallen)</li> <li>Weisungen für die Zoll- und sonstige amtliche Behandlung</li> <li>die Angabe, dass die Beförderung trotz einer gegenteiligen Abmachung den Bestimmungen dieses Übereinkommens unterliegt</li> </ul>  <p>(Rechtsquelle: CMR Art 6(1))</p> ",
  id: "DIHK_WiQ - 200000  ",
  inlineimg: false,
  score: 3,
  question: "Nennen Sie 4 Pflicht-Angaben im CMR Frachtbrief.",
  timelimit: 30,
  type: "SE",
  number: 2,
  duration: 100000
}, {
  answers: [],
  categories: ["BETRIEBSWIRTSCHAFTSLEHRE", "DIHK", "WWQ", "FB1", "BWL", "PROD"],
  correctAnswer: [],
  feedback: "<ul> <li>Ort und Tag der Ausstellung</li> <li>Name und Anschrift des Absenders</li> <li>Stelle und Tag der Übernahme des Gutes sowie die für die Ablieferung vorgesehene Stelle</li> <li>Name und Anschrift des Empfängers</li> <li>die übliche Bezeichnung der Art des Gutes und die Art der Verpackung, bei gefährlichen Gütern ihre allgemein anerkannte Bezeichnung</li> <li>Anzahl, Zeichen und Nummern der Frachtstücke</li> <li>Rohgewicht oder die anders angegebene Menge des Gutes</li> <li>die mit der Beförderung verbundenen Kosten (Fracht, Nebengebühren, Zölle und andere Kosten, die vom Vertragsabschluss bis zur Ablieferung anfallen)</li> <li>Weisungen für die Zoll- und sonstige amtliche Behandlung</li> <li>die Angabe, dass die Beförderung trotz einer gegenteiligen Abmachung den Bestimmungen dieses Übereinkommens unterliegt</li> </ul>  <p>(Rechtsquelle: CMR Art 6(1))</p> ",
  id: "DIHK_WiQ - 200000  ",
  inlineimg: false,
  score: 3,
  question: "Nennen Sie 4 Pflicht-Angaben im CMR Frachtbrief.",
  timelimit: 30,
  type: "SE",
  number: 3,
  duration: 100000
}, {
  answers: [],
  categories: ["BETRIEBSWIRTSCHAFTSLEHRE", "DIHK", "WWQ", "FB1", "BWL", "PROD"],
  correctAnswer: [],
  feedback: "<ul> <li>Ort und Tag der Ausstellung</li> <li>Name und Anschrift des Absenders</li> <li>Stelle und Tag der Übernahme des Gutes sowie die für die Ablieferung vorgesehene Stelle</li> <li>Name und Anschrift des Empfängers</li> <li>die übliche Bezeichnung der Art des Gutes und die Art der Verpackung, bei gefährlichen Gütern ihre allgemein anerkannte Bezeichnung</li> <li>Anzahl, Zeichen und Nummern der Frachtstücke</li> <li>Rohgewicht oder die anders angegebene Menge des Gutes</li> <li>die mit der Beförderung verbundenen Kosten (Fracht, Nebengebühren, Zölle und andere Kosten, die vom Vertragsabschluss bis zur Ablieferung anfallen)</li> <li>Weisungen für die Zoll- und sonstige amtliche Behandlung</li> <li>die Angabe, dass die Beförderung trotz einer gegenteiligen Abmachung den Bestimmungen dieses Übereinkommens unterliegt</li> </ul>  <p>(Rechtsquelle: CMR Art 6(1))</p> ",
  id: "DIHK_WiQ - 200000  ",
  inlineimg: false,
  score: 3,
  question: "Nennen Sie 4 Pflicht-Angaben im CMR Frachtbrief.",
  timelimit: 30,
  type: "SE",
  number: 4,
  duration: 100000
}];

var QuizRound = /*#__PURE__*/function (_DataStoreComponent) {
  (0, _inherits2["default"])(QuizRound, _DataStoreComponent);

  var _super = _createSuper(QuizRound);

  function QuizRound(props) {
    var _thisSuper, _thisSuper2, _this;

    (0, _classCallCheck2["default"])(this, QuizRound);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "innerForceUpdate", function () {
      _this.forceUpdate();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "initRound", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var questionNumber,
          _args = arguments;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              questionNumber = _args.length > 0 && _args[0] !== undefined ? _args[0] : 0;

              _this.setState({
                roundStartTime: (0, _now["default"])()
              }); // reset question number


              _EquizzerActions["default"].setCurrentQuestionStatusNumber(questionNumber); // check for the question & answer content height after few seconds (3s)
              // and decide whether to display scroll icon or not
              // setTimeout(() => this.showScrollIcon(0), 2000)


            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "calculatePadding", function () {
      var height;
      var width;

      if (_DeviceInfoHelper["default"].isBrowser()) {
        height = window.innerHeight;
        width = window.innerWidth;
      } else {
        // height = this.props.sidebarDocked ? Math.min(window.screen.availHeight, window.screen.availWidth) : Math.max(window.screen.availHeight, window.screen.availWidth)
        height = _this.props.sidebarDocked ? Math.min(window.innerHeight, window.innerWidth) : Math.max(window.innerHeight, window.innerWidth); // const width = this.props.sidebarDocked ? Math.max(window.screen.availHeight, window.screen.availWidth) - MAIN_MENU_WIDTH : Math.min(window.screen.availHeight, window.screen.availWidth)

        width = _this.props.sidebarDocked ? Math.max(window.innerHeight, window.innerWidth) - _Constants.MAIN_MENU_WIDTH : Math.min(window.innerHeight, window.innerWidth);
      }

      var perfectWidth = height / _Constants.PERFECT_RATIO + 30;

      _this.setState({
        padding: (width - perfectWidth) / 2,
        qaOuterDivHeight: document.body.offsetHeight - 117
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "increaseUpdateValue", function () {
      console.log('increasing update value');

      _this.setState({
        updateValue: _this.state.updateValue + 1
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "filterQuestions", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var roundNumber, gameRounds, roundInfo, currentRoundStates, currentGame, currentGameStates, answeredQuestionNumbers, unansweredQuestions, playerState, _answerObj, answerObj;

      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              roundNumber = (_this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME_ROUNDS].length || 1) - 1;
              gameRounds = _this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME_ROUNDS];
              roundInfo = gameRounds[roundNumber];
              currentRoundStates = JSON.parse((0, _stringify["default"])(_DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_CURRENT_ROUND_STATES) || {}));
              currentGame = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_GAME);
              currentGameStates = currentRoundStates[currentGame.id];

              if (currentGameStates) {
                console.log('filterQuestions', currentGameStates);
                currentGameStates.forEach(function (obj, index) {
                  delete obj.isUnanswered;
                });
              }

              if (!(!_this.state.filteredQuestions && currentRoundStates && currentRoundStates[currentGame.id] && currentRoundStates[currentGame.id].length > 0)) {
                _context2.next = 26;
                break;
              }

              answeredQuestionNumbers = currentRoundStates[currentGame.id].map(function (answer) {
                return answer.number;
              });
              unansweredQuestions = roundInfo.questions.filter(function (question) {
                return answeredQuestionNumbers.indexOf(question.number) === -1;
              });
              playerState = _this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER_PLAYERSTATE];

              _this.initRound(unansweredQuestions.length > 0 ? unansweredQuestions[0].number : 0);

              if (!(currentRoundStates && currentRoundStates[currentGame.id])) {
                _context2.next = 24;
                break;
              }

              currentGame.rounds[roundNumber].state[playerState] = JSON.parse((0, _stringify["default"])(currentRoundStates[currentGame.id]));
              roundInfo.state[_this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER_PLAYERSTATE]] = JSON.parse((0, _stringify["default"])(currentRoundStates[currentGame.id]));
              _context2.next = 17;
              return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_GAME_ROUNDS, gameRounds);

            case 17:
              _context2.next = 19;
              return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_GAME, currentGame);

            case 19:
              if (!(currentRoundStates[currentGame.id].length < roundInfo.questions.length)) {
                _context2.next = 24;
                break;
              }

              _answerObj = {
                number: unansweredQuestions[0].number || 0,
                value: [],
                score: 0,
                factor: 0,
                isUnanswered: true
              };
              currentRoundStates[currentGame.id].push(_answerObj);
              _context2.next = 24;
              return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_CURRENT_ROUND_STATES, JSON.parse((0, _stringify["default"])(currentRoundStates)));

            case 24:
              _this.setState({
                filteredQuestions: unansweredQuestions
              });

              return _context2.abrupt("return");

            case 26:
              answerObj = {
                number: 0,
                value: [],
                score: 0,
                factor: 0,
                isUnanswered: true
              };
              currentRoundStates[currentGame.id] = [answerObj];
              _context2.next = 30;
              return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_CURRENT_ROUND_STATES, JSON.parse((0, _stringify["default"])(currentRoundStates)));

            case 30:
              _this.setState({
                filteredQuestions: roundInfo.questions
              });

            case 31:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setCurrentQuestionIndex", function (index) {
      _this.setState({
        currentQuestionIndex: index
      });
    });
    _this.state = {
      round_overview: false,
      qaOuterDivHeight: document.body.offsetHeight - 117,
      //scrollIcon: false,
      roundStartTime: null,
      padding: null,
      updateValue: 0,
      questionIndex: 0,
      filteredQuestions: null,
      currentQuestionIndex: null //      orientation: window.screen.orientation.type   // unused

    };
    _this.kesiFeedbackTags = [];
    _this.calculateTimeout = null;
    _this.renderTimerBarFns = [];
    _this.renderTimerBarFn = null;
    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(QuizRound.prototype)), "setDataStorePaths", _thisSuper).call(_thisSuper, [_DataStore.DATA_STORE_PATHS.QD_ALL_GAME, _DataStore.DATA_STORE_PATHS.QD_GAME, _DataStore.DATA_STORE_PATHS.QD_USER, _DataStore.DATA_STORE_PATHS.QD_SELECTED_OPPONENT, _DataStore.DATA_STORE_PATHS.QD_CURRENT_QUESTION_STATUS, _DataStore.DATA_STORE_PATHS.QD_NETWORK_STATUS, _DataStore.DATA_STORE_PATHS.QD_GAME_ROUNDS, _DataStore.DATA_STORE_PATHS.QD_USER_PLAYERSTATE, _DataStore.DATA_STORE_PATHS.CONNECT_PARTNER_PRESENCES, _DataStore.DATA_STORE_PATHS.QD_CURRENT_ROUND_STATES]);
    (0, _get2["default"])((_thisSuper2 = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(QuizRound.prototype)), "addStoresAndKeys", _thisSuper2).call(_thisSuper2, [{
      store: _ThemeStore["default"],
      keys: ['currentTheme', 'quiz']
    }]);
    return _this;
  }

  (0, _createClass2["default"])(QuizRound, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // initialize the round
      this.calculatePadding(false);

      _NavigationManager["default"].setCurrentLocation('quiz_round');

      _ScreenHelper["default"].instance().addOnWindowSizeChangedListener(this.calculatePadding);

      if (!_DeviceInfoHelper["default"].isBrowser()) {
        if (window.screen.orientation) {
          window.screen.orientation.addEventListener('change', this.innerForceUpdate, false);
        }
      }

      this.filterQuestions();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      _ScreenHelper["default"].instance().removeOnWindowSizeChangedListener(this.calculatePadding);

      if (!_DeviceInfoHelper["default"].isBrowser()) {
        if (window.screen.orientation) {
          window.screen.orientation.removeEventListener('change', this.innerForceUpdate);
        }
      }

      clearTimeout(this.calculateTimeout);
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(QuizRound.prototype), "componentWillUnmount", this).call(this);
    }
  }, {
    key: "showScrollIcon",
    value: function showScrollIcon(qnum) {
      var qaInnerDiv = document.getElementById("question_".concat(qnum));

      if (qaInnerDiv && qaInnerDiv.scrollHeight > this.state.qaOuterDivHeight) {
        this.setState({
          scrollIcon: true
        });
      } else {
        this.setState({
          scrollIcon: false
        });
      }
    }
  }, {
    key: "showNextQuestion",
    value: function () {
      var _showNextQuestion = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(currentQuestion, isLastQuestion) {
        var qnum, currentRoundStates, currentGame, currentGameState, nextQuestionNum, elem, roundNumber, gameRounds, roundInfo, answerObj, roundQuestions, questionIds, gameTime;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.log('showNextQuestion', currentQuestion, isLastQuestion);
                qnum = currentQuestion.number;
                currentRoundStates = this.state.data[_DataStore.DATA_STORE_PATHS.QD_CURRENT_ROUND_STATES] || {};
                currentGame = this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME];
                currentGameState = currentRoundStates[currentGame.id] || [];

                if (isLastQuestion) {
                  _context3.next = 32;
                  break;
                }

                nextQuestionNum = qnum + 1;
                _context3.next = 9;
                return _EquizzerActions["default"].setCurrentQuestionStatusNumber(nextQuestionNum);

              case 9:
                // hide current (answered) question
                document.getElementById("question_".concat(qnum)).style.display = 'none'; // make next question visible and position it correctly

                elem = document.getElementById("question_".concat(nextQuestionNum));
                elem.style.visibility = 'visible';
                elem.style.position = '';
                elem.style.top = '';
                elem.style.left = '';
                this.renderTimerBarFn = this.renderTimerBarFns[nextQuestionNum]; // check for next question & answer content height
                // and decide whether to display scroll icon or not
                //  this.showScrollIcon(nextQuestionNum)
                // set the current question as unanswered to the current state (in case the user leaves the app, it will count as false).
                // if the user answers the question correct, the value will be replaced

                currentGameState.forEach(function (obj) {
                  delete obj.isUnanswered;
                });

                if (!currentGameState) {
                  _context3.next = 25;
                  break;
                }

                console.log('currentGameState', currentGameState);
                roundNumber = (this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME_ROUNDS].length || 1) - 1;
                gameRounds = this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME_ROUNDS];
                roundInfo = gameRounds[roundNumber];
                roundInfo.state[this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER_PLAYERSTATE]] = JSON.parse((0, _stringify["default"])(currentGameState));
                _context3.next = 25;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_GAME_ROUNDS, gameRounds);

              case 25:
                answerObj = {
                  number: nextQuestionNum,
                  value: [],
                  score: 0,
                  factor: 0,
                  isUnanswered: true
                };
                currentGameState.push(answerObj);
                currentRoundStates[currentGame.id] = currentGameState;
                _context3.next = 30;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_CURRENT_ROUND_STATES, JSON.parse((0, _stringify["default"])(currentRoundStates)));

              case 30:
                _context3.next = 42;
                break;

              case 32:
                // Disabled for now since we execute kesi actions after every question and not round like intended here

                /*
                const partners = this.state.data[DATA_STORE_PATHS.CONNECT_PARTNER_PRESENCES] || []
                console.log('SENDING MESSAGE TO PARTNER: ', partners.length, this.kesiFeedbackTags.length)
                if (this.kesiFeedbackTags.length > 0) {
                  for (let i = 0; i < partners.length; i++) {
                    sendPrivateMessage(ABLY_COMMANDS.FEEDBACK_TAGS, {tags: this.kesiFeedbackTags}, partners[i])
                  }
                }
                */
                currentRoundStates[currentGame.id] = [];
                _context3.next = 35;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_CURRENT_ROUND_STATES, JSON.parse((0, _stringify["default"])(currentRoundStates)));

              case 35:
                roundQuestions = this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME_ROUNDS][this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME].activeRound].questions;
                questionIds = [];
                roundQuestions.forEach(function (question, index) {
                  questionIds.push(question.id || index);
                }); // LOG: round start to end time

                _UserLogsService["default"].postRoundCompletionLog(this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER].id, this.state.data[_DataStore.DATA_STORE_PATHS.QD_SELECTED_OPPONENT].id, this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME].emsId, questionIds, this.state.roundStartTime, (0, _now["default"])());

                if (this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME].activeRound === this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME].maxRounds - 1) {
                  gameTime = {
                    start: new Date(this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME].dateCreated).getTime(),
                    end: new Date(this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME].lastUpdatedOnDevice).getTime()
                  }; // LOG: game start to end time

                  _UserLogsService["default"].postGameCompletionLog(this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER].groupName, this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER].id, this.state.data[_DataStore.DATA_STORE_PATHS.QD_SELECTED_OPPONENT].id, this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME].emsId, gameTime.start, gameTime.end);
                }

                console.log('quizRound current game before post', this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME]);
                this.props.onRoundComplete(this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME]);

              case 42:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function showNextQuestion(_x, _x2) {
        return _showNextQuestion.apply(this, arguments);
      }

      return showNextQuestion;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      if (this.state.padding === null || !this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME_ROUNDS] || !this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER_PLAYERSTATE] || !this.state.data[_DataStore.DATA_STORE_PATHS.QD_SELECTED_OPPONENT] || !this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER]) {
        return /*#__PURE__*/_react["default"].createElement(_Spinner["default"], null);
      }

      var roundNumber = (this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME_ROUNDS].length || 1) - 1;
      var roundInfo = this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME_ROUNDS][roundNumber];

      if (roundInfo.actionState === 'chooseCategory') {
        return /*#__PURE__*/_react["default"].createElement(_Spinner["default"], null);
      }

      var padding = this.state.padding; //    const longestSide = Math.max(window.screen.availHeight, window.screen.availWidth)

      var longestSide = Math.max(window.innerHeight, window.innerWidth);
      var containerPaddingStyle;

      if (_DeviceInfoHelper["default"].isBrowser()) {
        containerPaddingStyle = {
          paddingLeft: "".concat(padding, "px"),
          paddingRight: "".concat(padding, "px")
        };
      } else if (_DeviceInfoHelper["default"].isBrowser() || this.props.sidebarDocked || longestSide > _Constants.MIN_TABLET_LENGTH) {
        containerPaddingStyle = {
          paddingLeft: "".concat(padding, "px"),
          paddingRight: "".concat(padding, "px")
        };
      } else {
        containerPaddingStyle = {
          paddingLeft: '3%',
          paddingRight: '5%'
        };
      }

      var previousSequence = null;
      var containerStyles = _QuizRound["default"].quizRoundContainer;

      if (!this.state.filteredQuestions) {
        return null;
      }

      var firstQuestionNumber = this.state.filteredQuestions.length > 0 ? this.state.filteredQuestions[0].number : 0;
      console.log('quizround', roundInfo.state[this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER_PLAYERSTATE]]);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: containerStyles,
        style: containerPaddingStyle
      }, this.renderTimerBarFn ? this.renderTimerBarFn() : null, /*#__PURE__*/_react["default"].createElement(_QuizRoundHeader["default"], {
        className: _QuizRound["default"].quizHeader,
        userState: this.state.data[_DataStore.DATA_STORE_PATHS.QD_CURRENT_ROUND_STATES][this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME].id],
        questions: roundInfo.questions,
        opponent: this.state.data[_DataStore.DATA_STORE_PATHS.QD_SELECTED_OPPONENT],
        questionsPerRound: roundInfo.questions.length,
        styles: (0, _QuizRoundStyle.getHeaderStyles)(this.state),
        user: this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER],
        possiblePoints: roundInfo.questions
      }), /*#__PURE__*/_react["default"].createElement("div", {
        id: QUESTION_OUTER_DIV_ID,
        style: {
          maxHeight: "".concat(this.state.qaOuterDivHeight, "px"),
          height: '100%',
          overflow: 'scroll'
        }
      }, //MOCKED_QUESTION.map((question, index) => {
      roundInfo.questions.map(function (question, index) {
        var updatedQuestion = question;
        var isLastQuestion = index === roundInfo.questions.length - 1;
        updatedQuestion.round = roundNumber;
        updatedQuestion.category = roundInfo.category;
        var sequences = roundInfo.sequences || {};

        if (question.sequence !== previousSequence) {
          previousSequence = question.sequence;
          updatedQuestion.isFirstInSequence = true;
        }

        if (!updatedQuestion.number && updatedQuestion.number !== 0) {
          updatedQuestion.number = index;
        }

        var questionComponent = /*#__PURE__*/_react["default"].createElement(_Question["default"], {
          question: updatedQuestion,
          onSubmitAnswer: function onSubmitAnswer() {
            return _this2.showNextQuestion(updatedQuestion, isLastQuestion);
          },
          setTitle: _this2.props.setTitle,
          sidebarDocked: _this2.props.sidebarDocked,
          padding: padding,
          sequences: sequences,
          kesiFeedbackTags: _this2.kesiFeedbackTags,
          currentRound: roundNumber,
          isInKesi: _this2.props.isInKesi,
          parentDomId: QUESTION_OUTER_DIV_ID,
          setRenderTimerBarFn: function setRenderTimerBarFn(fn) {
            _this2.renderTimerBarFns[updatedQuestion.number] = fn;

            if (updatedQuestion.number === firstQuestionNumber) {
              _this2.renderTimerBarFn = fn;
            }
          },
          onTimerBarStateUpdate: _this2.increaseUpdateValue,
          numberOfQuestions: roundInfo.questions.length,
          setCurrentQuestionIndexFn: _this2.setCurrentQuestionIndex
        });

        return /*#__PURE__*/_react["default"].createElement("div", {
          id: "question_".concat(updatedQuestion.number),
          key: "question_".concat(updatedQuestion.number),
          style: updatedQuestion.number !== firstQuestionNumber ? {
            visibility: 'hidden',
            position: 'absolute',
            left: -10000,
            top: -10000
          } : {}
        }, questionComponent);
      })));
    }
  }]);
  return QuizRound;
}(_DataStoreComponent2["default"]);

exports["default"] = QuizRound;
QuizRound.propTypes = {
  setTitle: _propTypes["default"].func.isRequired,
  onRoundComplete: _propTypes["default"].func.isRequired,
  onReload: _propTypes["default"].func.isRequired,
  sidebarDocked: _propTypes["default"].bool,
  isInKesi: _propTypes["default"].bool
};
QuizRound.defaultProps = {
  isInKesi: false
};